import { makeObservable, observable } from 'mobx';
import DeployMode from './DeployMode';

export default class DeployPageModel {
  deployPopupIsShown: boolean;

  isDeploying: boolean;

  modelIsDeployed: boolean;

  deploymentError: string;

  // Which deploy mode is currently fetching last-commits (null = none). Per-mode
  // so only the clicked tab's button shows the spinner, not both. ponytail: this exists
  loadingDeployMode: DeployMode | null;

  impactPopupIsShown: boolean;

  lastCommits: {
    [key: string]: { author: string; date: string; isDeployValid: boolean };
  };

  constructor(other?: DeployPageModel) {
    if (other) {
      this.deployPopupIsShown = other.deployPopupIsShown;
      this.isDeploying = other.isDeploying;
      this.modelIsDeployed = other.modelIsDeployed;
      this.deploymentError = other.deploymentError;
      this.loadingDeployMode = other.loadingDeployMode;
      this.impactPopupIsShown = other.impactPopupIsShown;
      this.lastCommits = other.lastCommits;
    } else {
      this.deployPopupIsShown = false;
      this.isDeploying = false;
      this.modelIsDeployed = false;
      this.deploymentError = null;
      this.loadingDeployMode = null;
      this.impactPopupIsShown = false;
      this.lastCommits = {};
    }
    makeObservable(this, {
      deployPopupIsShown: observable,
      isDeploying: observable,
      modelIsDeployed: observable,
      deploymentError: observable,
      loadingDeployMode: observable,
      impactPopupIsShown: observable,
      lastCommits: observable,
    });
  }
}
